import brazilianFlag from "../assets/flags/Flag_of_Brazil.png";
import americanFlag from "../assets/flags/Flag_of_the_United_States.png";

const languages = [
    {
        language: 'Português',
        alt: 'Brazilian flag',
        img: brazilianFlag
    },
    {
        language: 'English',
        alt: 'American flag',
        img: americanFlag
    }
];

export default languages;